package api.dataclasses.stock

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class StockObject(
    @SerialName("Artikel") val article: String,
    @SerialName("Artikeleigenaar") val owner: String,
    @SerialName("Artikelgroep") val category: String,
    @SerialName("Artikelnummer") val articleNumber: String,
    @SerialName("Variantcode") val variantCode: String,
    @SerialName("Maatcode") val sizeCode: String,
    @SerialName("Kleur_omschrijving") val colorDescription: String,
    @SerialName("Omschrijving") val description: String,
    @SerialName("Benodigd") val neededStock: Double,
    @SerialName("Beschikbare_voorraad") val availableStock: Double,
    @SerialName("Toegewezen_Voorraad") val assignedStock: Double,
    @SerialName("Voorraad") val stock: Double
)